'use client';

import type { RegionRecentSelectItemType, RegionSelectorWidgetData } from '@weberus/shared-types';
import type { HomeLogPageNameValue } from '@/app/(pages)/sub-home/[category]/constants';
import { Chip } from '@yanolja-rnd/nol-design-system';
import { IcClose } from '@yanolja-rnd/nol-icons';
import { useState, type FC } from 'react';
import { YaTrackerImpression, clientLogStandardized } from '@weberus/client-tracker';
import { useDeleteRegionRecentSelected } from './api';

interface RecentSelectedProps {
  regionRecentSelected: RegionSelectorWidgetData['regionRecentSelected'];
  target: string;
  pageNameLog: HomeLogPageNameValue;
}

export const RecentSelected: FC<RecentSelectedProps> = ({ regionRecentSelected, target, pageNameLog }) => {
  const [recentSelected, setRecentSelected] = useState(regionRecentSelected?.items);
  const hasRegionRecentSelected = regionRecentSelected && recentSelected && recentSelected.length > 0;

  const { mutate: deleteRegion } = useDeleteRegionRecentSelected();

  const handleClientLog = (eventType: 'click' | 'impression', item: RegionRecentSelectItemType, cutomLog?: object) => {
    return clientLogStandardized(eventType, pageNameLog, {
      ...item.logMeta,
      regionNameDepth1: item.parentRegion?.title,
      ...cutomLog,
    });
  };

  return (
    <>
      {!!hasRegionRecentSelected && (
        <>
          <p className="mt-4 typography-subtitle-16-bold pc:mt-0 pc:typography-subtitle-20-bold">
            {regionRecentSelected.header.title}
          </p>
          <div className="mx-16 mb-20 mt-12 flex flex-wrap justify-center gap-x-4 gap-y-6 pc:mx-40 pc:mb-32 pc:mt-16 pc:gap-x-8 pc:gap-y-16">
            {recentSelected.map((item, index) => (
              <YaTrackerImpression key={index} onImpressed={() => handleClientLog('impression', item)}>
                <Chip
                  key={item.region.title}
                  rightIcon={<IcClose />}
                  onClick={() => {
                    item.action.web && (location.href = item.action.web);
                    handleClientLog('click', item);
                  }}
                  onRightIconClick={() => {
                    setRecentSelected((prev) => prev?.filter((prevItem) => prevItem.region.code !== item.region.code));
                    deleteRegion({ target, regionCode: item.region.code });
                    handleClientLog('click', item, {
                      object: 'deleteBtn',
                      objectType: 'deleteBtn',
                      regionChipName: item.region.title,
                    });
                  }}>
                  {item.region.title}
                </Chip>
              </YaTrackerImpression>
            ))}
          </div>
        </>
      )}
    </>
  );
};
